export default __webpack_public_path__ + "static/media/round-circel.5bf92b6a.gif";